import React from 'react'
import { Helmet } from 'react-helmet'

const SidenavTheme = ({ theme, settings }) => {
  function darkHoverStyle () {
    return theme.palette.mode === 'dark'
      ? `.navigation .nav-item:hover,
        .navigation .nav-item.active {
          color: ${theme.palette.text.primary};
        }`
      : ''
  }

  function lightHoverStyle () {
    return theme.palette.mode === 'light'
      ? `.navigation .nav-item:hover,
        .navigation .submenu {
          background: #EEEFE659;
        }
        .navigation .nav-item.active{
          background: #EEEFE6;
        }
      `
      : ''
  }

  const sidenavTheme = settings.sidebarThemes[settings.activeTheme] || theme
  return (
    <Helmet>
      <style>
        {`
        
        ${
          theme.palette.mode === 'dark'
            ? `.sidenav {
          color: ${theme.palette.text.secondary};
        }`
            : ' '
        }

        .sidenav__hold {
          background-image: url(${sidenavTheme.leftSidebar.bgImgURL});
          background-size: ${sidenavTheme.leftSidebar.bgStyle.backgroundSize};
          background-position: ${sidenavTheme.leftSidebar.bgStyle.backgroundPosition || 'center'};
          background-repeat: ${sidenavTheme.leftSidebar.bgStyle.backgroundRepeat || 'repeat'};
          opacity: 1 !important;
        }
        .sidenav__hold::after {
          background: ${theme.palette.primary.main};
          opacity: ${sidenavTheme.leftSidebar.bgOpacity};
        }

        ${lightHoverStyle()}
        ${darkHoverStyle()}
        
      `}
      </style>
    </Helmet>
  )
}

export default SidenavTheme
